import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import KeyprKey from '../../svg-icons/keypr/key';
import HousekeepingBadge from '../../components/HousekeepingBadge';
import GuestServicesBadge from '../../components/GuestServicesBadge';
import withAffiliateConfig from '../../utils/with-affiliate-config';
import { localize } from '../../i18n';
import './RoomCard.css';


function renderDeparture(id, checkoutDate) {
  if (checkoutDate) {
    const dateList = moment(checkoutDate).format('MMMM Do').split(' -- ');
    return dateList.map((dt, idx) => (
      <span key={`departure-${id}-${idx}`}>{dt}</span>
    ));
  }
  return null;
}

const RoomCard = (props) => {
  const {
    loc,
    hasConfigEnabled,
  } = props;

  let keyIconCls = 'light';
  const cardCls = ['md-card'];
  if (loc.attributes.is_locked === true) {
    keyIconCls = 'dark';
  }

  let guest = null;
  let guestInfo = (
    <div>{' '}</div>
  );
  let checkoutStatus = (
    <span className="title-secondary uk-text-danger">{props.t('Checked Out')}</span>
  );

  if (loc.attributes.checked_in_reservations.length > 0) {
    guest = loc.attributes.checked_in_reservations[0];
  }

  if (guest !== null) {
    guestInfo = [
      <div key="guest-name" className="uk-text-large uk-margin-small-bottom">
        {`${guest.first_name} ${guest.last_name}`}
      </div>,
      <div key="guest-email" className="uk-margin-small-bottom">{guest.email}</div>,
      <div key="guest-departure" className="uk-text-small">
        <strong>{props.t('Departure Date')}:</strong>
        <br />
        {renderDeparture(guest.id, guest.checkout_date)}
      </div>,
    ];
    checkoutStatus = (
      <span className="title-secondary uk-text-success">{props.t('Checked In')}</span>
    );
  }

  switch (loc.attributes.housekeeping_status) {
    case 'clean':
      cardCls.push('md-card-success');
      break;

    case 'dirty':
      cardCls.push('md-card-danger');
      break;

    case 'needs_inspection':
      cardCls.push('md-card-warning');
      break;

    default:
      cardCls.push('md-card-primary');
      break;
  }

  return (
    <div className="uk-margin-medium-top RoomCard" key={loc.id}>
      <Link to={`/access/rooms/${loc.id}/details`}>
        <div className={cardCls.join(' ')}>
          <div key="toolbar" className="md-card-toolbar">
            <h3 className="md-card-toolbar-heading-text">
              <span className="menu_icon">
                <KeyprKey className={`rotate35 ${keyIconCls}`} />
              </span>
              <span className="menu_title">#{loc.attributes.name}</span>
              {checkoutStatus}
            </h3>
          </div>
          <div key="content" className="md-card-content">
            <div className="uk-float-right uk-margin-small-right status-info">
              { hasConfigEnabled('gems_housekeeping_enabled') ?
                <HousekeepingBadge
                  className="uk-text-nowrap uk-text-right uk-margin-small-bottom"
                  labelClassName="uk-text-small"
                  status={loc.attributes.housekeeping_status}
                /> : null }
              <GuestServicesBadge
                className="uk-text-nowrap uk-text-right"
                labelClassName="uk-text-small"
                status={loc.attributes.guest_service_status}
              />
            </div>
            <div className="guest-info">
              {guestInfo}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

RoomCard.propTypes = {
  loc: PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    attributes: PropTypes.shape({
      housekeeping_status: PropTypes.string,
      guest_service_status: PropTypes.string,
      name: PropTypes.string,
      is_locked: PropTypes.bool,
    }),
  }),
  hasConfigEnabled: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default localize(withAffiliateConfig(RoomCard));



// WEBPACK FOOTER //
// ./src/views/rooms/RoomCard.js